import React, { useState } from 'react';
import { Row, Form, Col, Button, Badge, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { MdFileDownload, MdFilterAlt, MdFilterListOff, MdDomain, MdPlace, MdApps, MdGrain } from "react-icons/md";
import './Filter.css';

const Filter = ({
  user,
  cooperative,
  filter,
  companyNames,
  stateNames,
  typeEquipaments,
  grains,
  activeFilters,
  handleExportAllEquipments
}) => {
  const [showExportModal, setShowExportModal] = useState(false);

  const serials = JSON.parse(localStorage.getItem("equipment")) || [];

  const handleChange = (company, state, grain, typeEquipament) => {
    filter(company, state, grain, typeEquipament);
  };

  const handleClearFilters = () => {
    filter('', '', '', '');
  };

  const handleExportClick = () => {
    setShowExportModal(true);
  };

  const handleExportConfirm = (allData) => {
    setShowExportModal(false);
    handleExportAllEquipments(allData);
  };

  // Verificar se há filtros ativos
  const hasActiveFilters =
    activeFilters.company ||
    activeFilters.state ||
    activeFilters.grain ||
    activeFilters.typeEquipament;

  // Contar filtros ativos
  const countActiveFilters = () => {
    return [
      activeFilters.company,
      activeFilters.state,
      activeFilters.grain,
      activeFilters.typeEquipament
    ].filter(Boolean).length;
  };

  return (
    <div className="home-map-filter-host">
      <div className="home-map-filter">
        <Row className="gx-2 gy-2 align-items-center">
          {/* Título e botões em uma linha */}
          <Col xs={12} className="home-map-filter__header">
            <div className="home-map-filter__identity">
              <span className="home-map-filter__icon">
                <MdFilterAlt size={17} />
              </span>
              <h6 className="home-map-filter__title">
                Filtros
                {countActiveFilters() > 0 && (
                  <Badge className="home-map-filter__count" pill>
                    {countActiveFilters()}
                  </Badge>
                )}
              </h6>

              {cooperative?.name && (
                <h6 className="home-map-filter__meta d-none d-md-flex">
                  <span className="home-map-filter__divider" />
                  <span>{user?.hideSensitiveInfo ? '--' : cooperative.name}</span>
                </h6>
              )}

              <h6 className="home-map-filter__meta d-none d-md-flex">
                <span className="home-map-filter__divider" />
                <span>Equipamentos: {serials?.length}</span>
              </h6>
            </div>

            <div className="home-map-filter__actions">
              {hasActiveFilters && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Limpar filtros</Tooltip>}
                >
                  <Button
                    variant="link"
                    size="sm"
                    onClick={handleClearFilters}
                    className="home-map-filter__action home-map-filter__action--clear"
                    aria-label="Limpar filtros"
                  >
                    <MdFilterListOff size={14} />
                  </Button>
                </OverlayTrigger>
              )}

              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Exportar dados dos equipamentos para Excel</Tooltip>}
              >
                <Button
                  variant="link"
                  size="sm"
                  onClick={handleExportClick}
                  className="home-map-filter__action home-map-filter__action--export"
                >
                  <MdFileDownload size={16} />
                  <span className="d-none d-sm-inline">Relatório de Localização</span>
                </Button>
              </OverlayTrigger>
            </div>
          </Col>

          {/* Filtros em uma linha */}
          <Col xs={6} sm={6} md={3} className="px-1">
            <div className="home-map-filter__field">
              <MdDomain size={15} className="home-map-filter__field-icon d-none d-sm-block" />
              <Form.Select
                className={`home-map-filter__select ${activeFilters.company ? "is-active" : ""}`}
                value={activeFilters.company}
                onChange={({ target: { value } }) => handleChange(
                  value,
                  activeFilters.state,
                  activeFilters.grain,
                  activeFilters.typeEquipament
                )}
                disabled={!companyNames.length || user?.hideSensitiveInfo}
                aria-label="Seleção de unidades"
                size="sm"
              >
                <option value="">Unidades</option>
                {companyNames.map((item, index) => (
                  <option key={index} value={item}>{item}</option>
                ))}
              </Form.Select>
            </div>
          </Col>

          <Col xs={6} sm={6} md={3} className="px-1">
            <div className="home-map-filter__field">
              <MdPlace size={15} className="home-map-filter__field-icon d-none d-sm-block" />
              <Form.Select
                className={`home-map-filter__select ${activeFilters.state ? "is-active" : ""}`}
                value={activeFilters.state}
                onChange={({ target: { value } }) => handleChange(
                  activeFilters.company,
                  value,
                  activeFilters.grain,
                  activeFilters.typeEquipament
                )}
                disabled={!stateNames.length}
                aria-label="Seleção de estados"
                size="sm"
              >
                <option value="">Estados</option>
                {stateNames.map((item, index) => (
                  <option key={index} value={item}>{item}</option>
                ))}
              </Form.Select>
            </div>
          </Col>

          <Col xs={6} sm={6} md={3} className="px-1">
            <div className="home-map-filter__field">
              <MdGrain size={15} className="home-map-filter__field-icon d-none d-sm-block" />
              <Form.Select
                className={`home-map-filter__select ${activeFilters.grain ? "is-active" : ""}`}
                value={activeFilters.grain}
                onChange={({ target: { value } }) => handleChange(
                  activeFilters.company,
                  activeFilters.state,
                  value,
                  activeFilters.typeEquipament
                )}
                disabled={!grains.length}
                aria-label="Seleção por curvas"
                size="sm"
              >
                <option value="">Curvas</option>
                {grains.map((item, index) => (
                  <option key={index} value={item}>{item}</option>
                ))}
              </Form.Select>
            </div>
          </Col>

          <Col xs={6} sm={6} md={3} className="px-1">
            <div className="home-map-filter__field">
              <MdApps size={15} className="home-map-filter__field-icon d-none d-sm-block" />
              <Form.Select
                className={`home-map-filter__select ${activeFilters.typeEquipament ? "is-active" : ""}`}
                value={activeFilters.typeEquipament}
                onChange={({ target: { value } }) => handleChange(
                  activeFilters.company,
                  activeFilters.state,
                  activeFilters.grain,
                  value
                )}
                disabled={!typeEquipaments.length}
                aria-label="Seleção por equipamentos"
                size="sm"
              >
                <option value="">Equipamentos</option>
                {typeEquipaments.map((item, index) => (
                  <option key={index} value={item}>{item}</option>
                ))}
              </Form.Select>
            </div>
          </Col>
        </Row>

        {/* Exibir resumo de filtros ativos em dispositivos móveis (apenas se houver filtros) */}
        {hasActiveFilters && (
          <div className="home-map-filter__summary d-md-none">
            <div className="d-flex flex-wrap gap-1">
              {activeFilters.company && (
                <Badge className="home-map-filter__chip">
                  <MdDomain size={10} />
                  {activeFilters.company}
                </Badge>
              )}
              {activeFilters.state && (
                <Badge className="home-map-filter__chip">
                  <MdPlace size={10} />
                  {activeFilters.state}
                </Badge>
              )}
              {activeFilters.grain && (
                <Badge className="home-map-filter__chip">
                  <MdGrain size={10} />
                  {activeFilters.grain}
                </Badge>
              )}
              {activeFilters.typeEquipament && (
                <Badge className="home-map-filter__chip">
                  <MdApps size={10} />
                  {activeFilters.typeEquipament}
                </Badge>
              )}
            </div>
          </div>
        )}

        {/* Removido bloco de nome da cooperativa em dispositivos móveis */}
      </div>

      <Modal
        show={showExportModal}
        onHide={() => setShowExportModal(false)}
        centered
        size="sm"
        dialogClassName="home-map-export-modal"
      >
        <Modal.Header closeButton className="home-map-export-modal__header">
          <Modal.Title>Exportar Relatório</Modal.Title>
        </Modal.Header>
        <Modal.Body className="home-map-export-modal__body">
          <p>Qual período deseja exportar?</p>
          <div className="d-flex gap-2">
            <Button
              variant="outline-light"
              size="sm"
              disabled={user?.hideSensitiveInfo}
              onClick={() => handleExportConfirm(false)}
              className="flex-fill"
            >
              Último Registro
            </Button>
            <Button
              variant="success"
              size="sm"
              disabled={user?.hideSensitiveInfo}
              onClick={() => handleExportConfirm(true)}
              className="flex-fill home-map-export-modal__confirm"
            >
              Todo Histórico
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Filter;
